import { Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import Microsoft from "./Microsoft.svg.jsx";
import { buttonCss } from "./MicrosoftAnchor.style";

const propTypes = {
  children: PropTypes.string.isRequired,
  __cssFor: PropTypes.object,
};

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const MicrosoftAnchor = ({ children, __cssFor = {}, ...props }) => {
  return (
    <AnchorWithTrackEvent
      __cssFor={{ ...buttonCss, ...__cssFor }}
      icon={{
        SvgComponent: Microsoft,
        isIconBeforeText: true,
      }}
      objectType={objectTypes.user}
      actionName={actionNames.select}
      dataProps={{
        "data-qa-selector": "sign-in-with-microsoft",
      }}
      streamProperties={{
        description:
          "Select the button allowing the user to sign in with Microsoft",
      }}
      {...props}
    >
      <span>{children}</span>
    </AnchorWithTrackEvent>
  );
};

MicrosoftAnchor.propTypes = propTypes;

export default MicrosoftAnchor;
